import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog.component';

@Component({
  selector: 'app-abstract-associacao',
  templateUrl: './associacao.component.html',
  styleUrls: ['./associacao.component.css']
})
export class AbastractAssociacao implements OnInit {

  displayedColumns: string[] = ['select', 'nome'];

  dataSource: MatTableDataSource<any>;

  selection: SelectionModel<any>;

  tituloAssociacao: string = '';

  nomeCampoAssociacaoPai: string = '';

  nomeCampoAssociacaoFilho: string = '';

  formularioAssociacao: FormGroup;

  associacaoPai: any;

  listaPais: any[] = [];

  listaFilhos: any[] = [];

  constructor(private formBuilder: FormBuilder, private dialog: MatDialog) {

    this.dataSource = new MatTableDataSource<any>([]);

    this.selection = new SelectionModel<any>(true, []);

    this.formularioAssociacao = this.formBuilder.group({
      associacaoPai: ['', [Validators.required]]
    });

  }

  ngOnInit() {

    this.getListaDePais().subscribe(data => {

      this.listaPais = data;

      this.getListaDeFilhos().subscribe(data => {

        this.listaFilhos = data;

        this.configurarForm();

      });
    });
  }

  save() {

    this.configurarAssociacoesFilhas(this.selection.selected);

    this.salvarAssociacao(this.associacaoPai).subscribe(data => {
      // console.log(data)

      this.dialog.open(InfoDialogComponent, {
        data: {
          title: 'Info',
          message: this.tituloAssociacao + ' atualizado com sucesso!'
        }
      });

    }, error => {
      console.log(error);
    });
  }

  onSubmit() {
    this.save();
  }

  get formControl() {
    return this.formularioAssociacao.controls;
  }

  configurarForm(): void {

    this.limparSelecaoDaListaDeFilhos();

    this.dataSource = new MatTableDataSource<any>(this.listaFilhos);

  }

  onChangePai(event: MatSelectChange): void {

    if (event.value) {

      this.associacaoPai = event.value;

      this.limparSelecaoDaListaDeFilhos();

      if (this.associacaoPai && this.listaFilhos) {

        for (let currentFilho of this.listaFilhos) {

          for (let currentFilhoSelecionado of this.getListaDeFilhosSelecionados()) {

            if (currentFilho.id == this.getIdFilhoFromAssociacaoComPai(currentFilhoSelecionado)) {

              this.selection.select(currentFilho)
              break;
            }
          }
        }
      }
    }

    /*
    for (let currentFilho of this.listaFilhos) {
      console.log(currentFilho.id + ' - ' + currentFilho.nome + ': ' + currentFilho.filhoSelecionado);
    }
    */

  }

  limparSelecaoDaListaDeFilhos(): void {

    this.selection.clear()

  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  getListaDePais(): Observable<any> {
    throw new Error('Sobrescreva o método: getListaDePais().');
  };

  getListaDeFilhos(): Observable<any> {
    throw new Error('Sobrescreva o método: getListaDeFilhos().');
  }

  getListaDeFilhosSelecionados(): any {
    throw new Error('Sobrescreva o método: getListaDeFilhosSelecionados().');
  }

  getIdFilhoFromAssociacaoComPai(currentAssociacao: any): any {
    throw new Error('Sobrescreva o método: getIdPaiFromAssociacao().');
  }

  configurarAssociacoesFilhas(associacoesFilhas: any): void {
    throw new Error('Sobrescreva o método: configurarAssociacoesFilhas().');
  }

  salvarAssociacao(value: any): Observable<Object> {
    throw new Error('Sobrescreva o método: salvarAssociacao().');
  }

}
